import { FC, useState } from 'react';

import { ConfirmModal } from '@/components/ConfirmModal';
import { useI18nContext } from '@/i18n/I18n';

export const FirstTipModal: FC = () => {
  const [$t] = useI18nContext();
  const [isFirstEnter, setIsFirstEnter] = useState<boolean>(
    !window.localStorage.getItem('apiTipShowed'),
  );
  const onConfirmKnow = () => {
    window.localStorage.setItem('apiTipShowed', 'true');
    setIsFirstEnter(false);
  };

  return (
    <ConfirmModal
      isVisible={isFirstEnter}
      title={$t('apiCreateTipTitle')}
      content={$t('apiPopTip')}
      okBtnText={$t('iKnow')}
      onCancel={onConfirmKnow}
      onConfirm={onConfirmKnow}
    />
  );
};
